import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-jet-black text-white">
      {/* Main Footer */}
      <div className="container mx-auto px-4 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-12 h-12 bg-crimson rounded-lg flex items-center justify-center">
                <i className="ri-plane-fill text-white text-2xl"></i>
              </div>
              <div className="flex flex-col">
                <span className="text-white font-heading font-bold text-xl leading-tight">TopUp</span>
                <span className="text-crimson font-heading font-semibold text-xs tracking-wider">CONCIERGE</span>
              </div>
            </div>
            <p className="text-soft-grey text-sm mb-6 leading-relaxed">
              Bold Experiences. Premium Concierge. Your trusted partner for luxury tours and VIP services across the UAE.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-dark-grey rounded-full flex items-center justify-center hover:bg-crimson transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-dark-grey rounded-full flex items-center justify-center hover:bg-crimson transition-colors cursor-pointer">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-dark-grey rounded-full flex items-center justify-center hover:bg-crimson transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-dark-grey rounded-full flex items-center justify-center hover:bg-crimson transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-bold text-lg mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li><Link to="/tours" className="text-soft-grey hover:text-crimson transition-colors text-sm cursor-pointer">Tours & Experiences</Link></li>
              <li><Link to="/dubai-tours" className="text-soft-grey hover:text-crimson transition-colors text-sm cursor-pointer">Dubai Tours</Link></li>
              <li><Link to="/abu-dhabi-tours" className="text-soft-grey hover:text-crimson transition-colors text-sm cursor-pointer">Abu Dhabi Tours</Link></li>
              <li><Link to="/services" className="text-soft-grey hover:text-crimson transition-colors text-sm cursor-pointer">Luxury Services</Link></li>
              <li><Link to="/about" className="text-soft-grey hover:text-crimson transition-colors text-sm cursor-pointer">About Us</Link></li>
              <li><Link to="/contact" className="text-soft-grey hover:text-crimson transition-colors text-sm cursor-pointer">Contact</Link></li>
            </ul>
          </div>

          {/* Popular Tours */}
          <div>
            <h4 className="font-heading font-bold text-lg mb-6">Popular Tours</h4>
            <ul className="space-y-3">
              <li><Link to="/tour/desert-safari" className="text-soft-grey hover:text-crimson transition-colors text-sm cursor-pointer">Desert Safari</Link></li>
              <li><Link to="/tour/burj-khalifa" className="text-soft-grey hover:text-crimson transition-colors text-sm cursor-pointer">Burj Khalifa Tour</Link></li>
              <li><Link to="/tour/dubai-city" className="text-soft-grey hover:text-crimson transition-colors text-sm cursor-pointer">Dubai City Tour</Link></li>
              <li><Link to="/tour/abu-dhabi-city" className="text-soft-grey hover:text-crimson transition-colors text-sm cursor-pointer">Abu Dhabi City Tour</Link></li>
              <li><Link to="/tour/theme-parks" className="text-soft-grey hover:text-crimson transition-colors text-sm cursor-pointer">Theme Parks</Link></li>
              <li><Link to="/deals" className="text-soft-grey hover:text-crimson transition-colors text-sm cursor-pointer">Deals & Combos</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-heading font-bold text-lg mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <i className="ri-map-pin-fill text-crimson text-xl mt-1"></i>
                <span className="text-soft-grey text-sm">United Arab Emirates</span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-phone-fill text-crimson text-xl"></i>
                <a href="tel:+971562022818" className="text-soft-grey hover:text-crimson transition-colors text-sm cursor-pointer">+971 56 202 2818</a>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-mail-fill text-crimson text-xl"></i>
                <a href="mailto:soumish@topupconcierge.com" className="text-soft-grey hover:text-crimson transition-colors text-sm cursor-pointer">soumish@topupconcierge.com</a>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-whatsapp-fill text-crimson text-xl"></i>
                <a href="https://wa.me/971562022818" className="text-soft-grey hover:text-crimson transition-colors text-sm cursor-pointer">WhatsApp Us</a>
              </li>
            </ul>

            {/* Payment Methods */}
            <div className="mt-6">
              <p className="text-soft-grey text-xs mb-3">We Accept</p>
              <div className="flex space-x-2">
                <div className="w-10 h-7 bg-dark-grey rounded flex items-center justify-center">
                  <i className="ri-visa-line text-white text-lg"></i>
                </div>
                <div className="w-10 h-7 bg-dark-grey rounded flex items-center justify-center">
                  <i className="ri-mastercard-line text-white text-lg"></i>
                </div>
                <div className="w-10 h-7 bg-dark-grey rounded flex items-center justify-center">
                  <i className="ri-bank-card-line text-white text-sm"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-dark-grey">
        <div className="container mx-auto px-4 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-soft-grey text-sm">
              © 2024 TopUp Concierge. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <Link to="/privacy" className="text-soft-grey hover:text-crimson transition-colors text-sm cursor-pointer">Privacy Policy</Link>
              <Link to="/terms" className="text-soft-grey hover:text-crimson transition-colors text-sm cursor-pointer">Terms & Conditions</Link>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-soft-grey hover:text-crimson transition-colors text-sm cursor-pointer">Powered by Readdy</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
